import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Label } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import GraphQl from '../../../GraphQL';
import DateField from '../../../shared/components/form/DateField';
import HourField from '../../../shared/components/form/HourField';
import Select from '../../../shared/components/form/Select';
import { itensTabletByBrother } from '../../../shared/queries/Appointment';
import { showNotificationAutoDestroy } from '../../../shared/components/ShowNotification';
import SmartButton from '../../../shared/components/SmartButton';
import SmartCard from '../../../shared/components/SmartCard';
import { getUniformed } from '../../../shared/utils/smartutils';

function EditAppointmentModal(props) {
  const { t, dto, initialize, currentValue, student, updateItem } = props;

  const [values, setValues] = useState();
  const [newItem, setnewItem] = useState();
  const [selectedDate, setSelectedDate] = useState();
  const [selectedHour, setSelectedHour] = useState();
  const [complement, setComplement] = useState();

  const onChangeDate = (date) => {
    setSelectedDate(date);
  };

  const onChangeHour = (event) => {
    setSelectedHour(event.target.value);
  };

  const listValues = () => {
    if (dto.idItemNote) {
      const query = itensTabletByBrother(dto.idItemNote);
      GraphQl(query, {})
        .then((res) => {
          res.itensTabletByBrother = res.itensTabletByBrother.map((item) => ({
            ...item,
            label: item.shortName,
            value: item.id,
          }));
          setValues(res.itensTabletByBrother);
        })
        .catch(() => {
          showNotificationAutoDestroy(
            'danger',
            t('errors.title'),
            t('errors.error-to-loading')
          );
        });
    }
  };

  const saveItemHandler = (value) => {
    updateItem(value);
  };

  const updateToSaveHandler = () => {
    const savedItem = [dto];
    const mappedSavedItem = savedItem.map((item) => ({
      id: item.id,
      idResponsible: item.idResponsible,
      idStudent: item.student.id,
      firstLevelItemCode: item.firstLevelItemCode,
      typeOfMeal: item.typeOfMeal,
      valueNote: newItem.itemValue ? newItem.itemValue : 0,
      dateNote: selectedDate ? new Date(selectedDate).getTime() : item.dateNote,
      hourNote: selectedHour || dto.hourNote,
      noteComplement: complement || item.noteComplement,
      idItemNote: newItem.id,
      createEmployeeId: item.createEmployeeId,
    }));
    saveItemHandler(mappedSavedItem);
  };

  const getResponsibleField = () =>
    dto.responsible && dto.responsible.fullName
      ? dto.responsible.fullName
      : getUniformed(t).label;

  const onItemSelectionChangeHandler = (value) => {
    if (value) {
      setnewItem(value);
    }
  };

  useEffect(() => {
    initialize(dto);
    listValues();
  }, [dto]);

  return (
    <SmartCard>
      <form className="form">
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.classes-names')}
          </span>
          <div className="form__form-group-field">
            <Label>{dto.class}</Label>
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.student')}</span>
          <div className="form__form-group-field">
            <Label>{student}</Label>
          </div>
        </div>
        {!!dto.responsible && (
          <div className="form__form-group">
            <span className="form__form-group-label">
              {t('general.responsible-account')}
            </span>
            <div className="form__form-group-field">
              <Label>{getResponsibleField()}</Label>
            </div>
          </div>
        )}
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('mnt_appointment.currentValue')}
          </span>
          <div className="form__form-group-field">
            <Label>{currentValue}</Label>
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('mnt_appointment.newValue')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="newValue"
              type="text"
              component={Select}
              placeholder={t('mnt_appointment.newValue')}
              options={values}
              onChange={onItemSelectionChangeHandler}
            />
          </div>
        </div>
        <div className="form__form-group--2_columns">
          <div className="form__form-group">
            <span className="form__form-group-label">{t('general.date')}</span>
            <div className="form__form-group-field">
              <Field
                name="dateNote"
                type="text"
                component={DateField}
                placeholder={t('general.date')}
                onChange={onChangeDate}
              />
            </div>
          </div>
          <div className="form__form-group">
            <span className="form__form-group-label">{t('general.hour')}</span>
            <div className="form__form-group-field">
              <Field
                name="hourNote"
                type="text"
                component={HourField}
                placeholder={t('general.hour')}
                onChange={onChangeHour}
              />
            </div>
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('mnt_appointment.adjunct')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="noteComplement"
              type="text"
              component="textarea"
              placeholder={t('mnt_appointment.adjunct')}
              onChange={(event) => setComplement(event.target.value)}
            />
          </div>
        </div>
        <SmartButton
          label={t('general.save')}
          color="success"
          disabled={!newItem}
          onClick={updateToSaveHandler}
        />
      </form>
    </SmartCard>
  );
}

EditAppointmentModal.propTypes = {
  t: PropTypes.func.isRequired,
  dto: PropTypes.shape(PropTypes.shape).isRequired,
  initialize: PropTypes.func.isRequired,
  student: PropTypes.string.isRequired,
  currentValue: PropTypes.string.isRequired,
  updateItem: PropTypes.func.isRequired,
};

export default reduxForm({
  form: 'EditAppoitmentModal',
  keepDirtyOnReinitialize: true,
  enableReinitialize: true,
})(withTranslation('common')(EditAppointmentModal));
